export default __webpack_public_path__ + "static/fci-0dd081be3d6c24d8ec23dd2e745981db.svg";